import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WORKFLOWS, WorkflowsState, NodeConfiguration } from './types';

const initialState: WorkflowsState = {
  showNodesType: false,
  clickedPlusNodeId: null,
  selectedTrigger: null,
  nodeConfigurations: {},
};

export const workflowsSlice = createSlice({
  name: WORKFLOWS,
  initialState,
  reducers: {
    setShowNodesType: (state, action: PayloadAction<string | undefined>) => {
      state.showNodesType = !state.showNodesType;
      state.clickedPlusNodeId = state.showNodesType ? action.payload || null : null;
    },
    setSelectedTrigger: (state, action: PayloadAction<{ id: number; name: string; model?: string }>) => {
      state.selectedTrigger = action.payload;
    },
    clearSelectedTrigger: state => {
      state.selectedTrigger = null;
    },
    setNodeConfiguration: (state, action: PayloadAction<NodeConfiguration>) => {
      state.nodeConfigurations[action.payload.nodeId] = action.payload;
    },
    removeNodeConfiguration: (state, action: PayloadAction<string>) => {
      delete state.nodeConfigurations[action.payload];
    },
    clearAllNodeConfigurations: state => {
      state.nodeConfigurations = {};
    },
  },
});

export const {
  setShowNodesType,
  setSelectedTrigger,
  clearSelectedTrigger,
  setNodeConfiguration,
  removeNodeConfiguration,
  clearAllNodeConfigurations,
} = workflowsSlice.actions;
export default workflowsSlice.reducer;
